// Used Images

// Logo
export const logo = "/logos/logo.svg";

// Used Icons
export const arrowIcon = "/arrow-icon.svg";
export const arrowIcon3 = "/arrow-icon-cta.svg";
export const arrowIcon4 = "/arrow-prev.svg";
export const arrowIcon5 = "/arrow-next.svg";

// Social Icons
export const whatsappIcon = "/whatsapp-icon-asset.svg";

// Decorative Elements
export const line1 = "/line-1.svg";
export const line2 = "/line-2.svg";
